/**
 * If user has boss level privlages.
 *
 * ```
 * isBoss(userContext)
 * ```
 * @param { Object } userContext: The userContext object of the user.
 * @returns { Boolean } If user is boss.
 */
export const isBoss = (userContext) => (userContext ? userContext.isBossOrSalesBossLevel : false);

/**
 * Gets the project of the user.
 *
 * ```
 * getProject(userContext)
 * ```
 * @param { Object } userContext: The userContext object of the user.
 * @returns { Object } The user's project.
 */
export const getProject = (userContext = {}) => userContext.project || {};

/**
 * Gets the time zone of the user.
 *
 * ```
 * getTimeZone(userContext)
 * ```
 * @param { Object } userContext: The userContext object of the user.
 * @returns { String } The user's time zone.
 */
export const getTimeZone = (userContext) => getProject(userContext).timeZone;
